import React from "react"
import styled from "styled-components"
import media from "styles/media"
import colors from "styles/colors"
import text from "styles/text"
import quoteMarks from "images/Parenthesis.svg"
import StyledLink from "../../StyledLink"

const OverviewQuote = ({ content }) => {
  console.log(content)
  return (
    <Wrapper>
      <Quotation src={quoteMarks} alt={"styled-quotation"} />
      <ContentDiv>
        {content?.headshot && (
          <QuoteImage
            src={content?.headshot?.sourceUrl}
            alt={content?.headshot?.altText}
          />
        )}
        <QuoteCopy>
          <Header>{content?.header}</Header>
          <BodyCopy dangerouslySetInnerHTML={{ __html: content?.bodyCopy }} />
          <Attribution>{content?.attribution}</Attribution>
        </QuoteCopy>
        {content?.linkText && (
          <StyledLink href={content?.linkUrl}>{content?.linkText}</StyledLink>
        )}
      </ContentDiv>
    </Wrapper>
  )
}

export default OverviewQuote

const Attribution = styled.p`
  ${text.bodySm};

  ${media.mobile} {
    ${text.bodySmBold};
  }
`

const BodyCopy = styled.p`
  ${text.bodyLg};

  ${media.mobile} {
    ${text.bodyMd};
  }
`

const Header = styled.h4`
  ${text.h4};
`

const QuoteCopy = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 0.347vw;
  ${media.fullWidth} {
    gap: 5px;
  }

  ${media.tablet} {
    gap: 0.488vw;
  }

  ${media.mobile} {
    gap: 1.168vw;
  }
`

const QuoteImage = styled.img`
  height: 7.431vw;
  width: 7.431vw;
  border-radius: 8px;
  ${media.fullWidth} {
    height: 107px;
    width: 107px;
  }

  ${media.tablet} {
    height: 10.449vw;
    width: 10.449vw;
  }

  ${media.mobile} {
    display: none;
  }
`

const Quotation = styled.img`
  position: absolute;
  top: -1.389vw;
  left: 2.083vw;
  width: 2.778vw;
  height: 2.778vw;
  z-index: 2;
  ${media.fullWidth} {
    top: -20px;
    left: 30px;
    width: 40px;
    height: 40px;
  }

  ${media.tablet} {
    top: -1.953vw;
    left: 2.93vw;
    width: 3.906vw;
    height: 3.906vw;
  }

  ${media.mobile} {
    top: -4.673vw;
    left: 7.944vw;
    width: 9.346vw;
    height: 9.346vw;
  }
`

const ContentDiv = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: ${colors.lightPurpleGrey};
  width: 79.444vw;
  border-radius: 1.667vw;
  padding: 2.083vw 2.222vw;
  gap: 1.667vw;

  ${media.fullWidth} {
    width: 1144px;
    border-radius: 24px;
    padding: 30px 32px;
    gap: 24px;
  }

  ${media.tablet} {
    width: 91.992vw;
    border-radius: 2.344vw;
    padding: 2.93vw 3.125vw;
    gap: 2.344vw;
  }

  ${media.mobile} {
    width: 88.084vw;
    border-radius: 5.607vw;
    padding: 8.009vw 3.271vw;
    gap: 5.607vw;
  }
`

const Wrapper = styled.div`
  position: relative;
  display: flex;
  z-index: 1;
`
